import { signOut } from 'firebase/auth';
import { auth } from '../authConfig';

export async function signOutFrontend() {
  localStorage.removeItem('firebase_token');
  try {
    await signOut(auth);
    window.location.href = '/';
  } catch (err) {
    console.error('Firebase logout failed', err);
    window.location.href = '/';
  }
}